import ReactMarkdown from 'react-markdown';
import styles from './AssistantSidebar.module.scss';

export const Message = ({ message }) => {
	const isUser = message.role === 'user';
	const isError = message.isError;
	const sources = !isUser && message.sources?.length > 0 ? message.sources : null;

	return (
		<div className={`${styles.message} ${isUser ? styles.messageUser : styles.messageAssistant} ${isError ? styles.messageError : ''}`}>
			<div className={styles.messageContent}>
				{isUser ? message.content : <ReactMarkdown>{message.content}</ReactMarkdown>}
				{sources && (
					<div className={styles.messageSources}>
						<span className={styles.sourcesLabel}>Relevant links:</span>
						{sources.map((source, i) => (
							<a key={i} href={source.url} target="_blank" rel="noopener noreferrer" className={styles.sourceLink}>
								{source.title}
							</a>
						))}
					</div>
				)}
			</div>
		</div>
	);
};
